import { Loader2 } from 'lucide-react'

type EmbedStatusProps = {
  /** Shown while connecting; an error message replaces the spinner. */
  message: string
  isError?: boolean
}

/** Full-screen status while the embedded editor connects to its host, or why it couldn't. */
export function EmbedStatus({ message, isError = false }: EmbedStatusProps) {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-background px-6">
      <div
        role={isError ? 'alert' : 'status'}
        className="flex items-center gap-3 text-sm text-muted-foreground"
      >
        {isError ? null : <Loader2 className="size-4 animate-spin" aria-hidden="true" />}
        <span className={isError ? 'text-destructive' : undefined}>{message}</span>
      </div>
    </div>
  )
}
